/** Remove notebook link capabilities from telemetry URL strings. */
export function redactShareTokens(value: string): string {
  return value.replace(/([#&]token=)[a-f0-9]{64}/gi, "$1[redacted]")
}
